import { useQuery } from "@tanstack/react-query";

import { getBettingMarketWithTranslations } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "./bettingMarketsQueryKeys";

export const useBettingMarketWithTranslations = (id: number | null) => {
  return useQuery({
    queryKey: [BettingMarketsQueryKeys.BettingMarketWithTranslations, id],
    queryFn: () => getBettingMarketWithTranslations(id!),
    enabled: id !== null,
  });
};
